// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import * as _ from "lodash";
import { connect } from 'react-redux';
import { MAX_TRADES } from '../../helpers/team';
import colors from '../../assets/css/colors';
import { below } from '../../assets/css/media';
import * as selectors from '../../modules/selectors';
import {
	PageTitle,
	ButtonPrimary,
	ButtonSecondary,
	RotatedLabel,
	PlayerTableCell,
	LoadingSpinner,
	ModalContainer,
	ModalInnerTitle,
	BorderedIcon,
	TradeInCell,
	TradeOutCell
} from '../';
import Plus from '../Icons/Plus';
import Trade from '../Icons/Trade';
import FA from '../Icons/FA';
import * as actions from '../../modules/actions';

type Props = {
	type: string,
	fa: {
		new_player_id: number,
		old_player_id: number
	},
	team: {
		new_player_id: Array<number>,
		old_player_id: Array<number>
	},
	players_by_id: Object,
	cancelRequest: Function,
	removeOutPlayer: Function,
	makeTeamToTeamTrade: Function,
	removeInPlayer: Function,
	clearTradeErrors: Function,
	postRequestWaiver: typeof actions.teamsDraft.postRequestWaiver,
	league: Object,
	waiver_requests: string,
	postRequestWaiverClear: typeof actions.teamsDraft.postRequestWaiverClear,
	reFetchData: Function,
	trade_error: boolean | string,
	MAX_TRADES: number,
	user_team: Object
}

type State = {
	show_trade_confirm_modal: boolean,
	show_fa_confirm_modal: boolean,
	is_fa_pending: boolean,
};

const PlayersOnTradeTitle = ({ title }) => (
	<PageTitle>
		{title}
	</PageTitle>
);

const ButtonsWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 1em 0;
	button {
		width: 200px;
		margin: 0 .5em;
	}
`;

const PlayerCellWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	margin-bottom: 10px;

	> div {
		flex-basis: 50%;
	}
`;

const PlayerCellWrapperLast = styled(PlayerCellWrapper)`
	position: relative;
	overflow: hidden;

	&:after {
		position: absolute;
		content: '';
		background-image: radial-gradient(50% 67%, rgba(0,58,49,.3) 0%, rgba(0,58,49,0) 68%);
		width: 40%;
		height: 100%;
		top: 60%;
		${below.desktop`
			${css`
				background: transparent;
			`}
		`}
	}

	> div{
		opacity: .3;
	}
`;

const EmptyCell = styled.div`
	background: ${colors.lightGreen};
	color: #003129;
	font-size: 12px;
	line-height: 1.5;
	display: flex;
	align-items: center;
`;

const EmptyInCellStyled = styled(EmptyCell)`
	svg {
		margin: 0 20px 0 35px;
		${below.desktop`
			margin: 0 10px 0 15px;
		`}
	}
`;

const EmptyOutCellStyled = styled(EmptyCell)`
	text-align: right;
	flex-direction: row-reverse;
	svg {
		margin: 0 35px 0 20px;
		${below.desktop`
			margin: 0 15px 0 10px;
		`}
	}
`;

const ConfirmModalContent = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 1em 2em 40px;
	${below.desktop`
		${css`
			margin: 1em 0;
		`}
	`}
`;
const TradeCells = styled.div`
	box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
	flex-basis: 40%;
	${below.desktop`
		flex-basis: 50%;
	`}
	> div {
		margin-bottom: 10px;
		&:last-child {
			margin-bottom: 0;
		}
		${below.desktop`
			${css`
				width: 100%;
			`}
		`}

	}
	${below.desktop`
		${css`
			${PlayerTableCell} {
				min-width: 100px;
				flex-basis: 100%;
			}
		`}
	`}
`;
const EmptyInCell = ({ is_team }) => (
	<EmptyInCellStyled>
		<RotatedLabel
			background={colors.liveGreen}
			text="IN"
			border_radius="2px 0 0 2px"
			rotate="-90" />
		<Plus size="1.25" />
		<p>
			{is_team ? 'Add a player to the trade below' : 'Add Free Agent'}
		</p>

	</EmptyInCellStyled>
);

const EmptyOutCell = ({ is_team }) => (
	<EmptyOutCellStyled>
		<RotatedLabel
			background={colors.red}
			text="OUT"
			border_radius="0 2px 2px 0"
			rotate="90" />
		<Plus size="1.25" />
		<p>
			{is_team ? 'Add a player to the trade below' : 'Release one of your players'}
		</p>

	</EmptyOutCellStyled>
);

const BorderedIconStyled = styled(BorderedIcon)`
	font-size: 2em;
`;
class PlayersOnTradeComponent extends React.Component<Props, State> {
	state = {
		show_trade_confirm_modal: false,
		show_fa_confirm_modal: false,
		is_fa_pending: false,
	};
	static defaultProps = {
		players: [],
		type: 'fa',
		fa: {
			new_player_id: 0,
			old_player_id: 0
		},
		team: {
			new_player_id: [0],
			old_player_id: [0]
		},
		MAX_TRADES: MAX_TRADES
	};
	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'makeFARequest',
			'getTeamPlayerCells',
			'handleErrorModalClose',
			'handleTradeConfirmModal',
			'handleFAConfirmModal'
		]);
	}
	componentDidUpdate(prev_props) {
		if (!_.isEmpty(this.props.waiver_requests)) {
			const { postRequestWaiverClear, reFetchData } = this.props;
			postRequestWaiverClear();
			reFetchData();
		}
	}

	get requests() {
		const { type } = this.props;

		if (type === 'fa') {
			return this.fa_requests;
		}
		return this.team_requests;
	}

	//FA
	get fa_requests() {
		return (
			<React.Fragment>
				{this.fa_player_cells}
				{this.fa_buttons}
			</React.Fragment>
		);
	}
	get fa_player_cells() {
		const {
			players_by_id,
			fa: { new_player_id, old_player_id },
			removeOutPlayer,
			removeInPlayer
		} = this.props;
		const new_player = players_by_id[new_player_id],
			old_player = players_by_id[old_player_id];
		if (_.isEmpty(players_by_id)) {
			return <LoadingSpinner />;
		}

		return (
			<PlayerCellWrapper>
				{new_player_id ? (
					<TradeInCell player={new_player} removePlayer={removeInPlayer} />
				) : (
					<EmptyInCell is_team={false} />
				)}
				{old_player_id ? (
					<TradeOutCell player={old_player} removePlayer={removeOutPlayer} />
				) : (
					<EmptyOutCell is_team={false} />
				)}
			</PlayerCellWrapper>
		);
	}
	get fa_buttons() {
		const { fa: { new_player_id, old_player_id }, cancelRequest, user_team } = this.props;
		const { players_margin } = user_team;
		const is_under_margin = players_margin < 0 && new_player_id !== 0;
		const is_request_disabled = [new_player_id, old_player_id].includes(0) && !is_under_margin;

		
		return (
			<ButtonsWrapper>
				<ButtonSecondary onClick={cancelRequest}>
					CANCEL REQUEST
				</ButtonSecondary>
				<ButtonPrimary disabled={is_request_disabled}
					onClick={is_request_disabled ? null : this.handleFAConfirmModal}>
					MAKE REQUEST
				</ButtonPrimary>
			</ButtonsWrapper>
		);
	}
	// Team to team
	get team_requests() {
		const { players_by_id, MAX_TRADES } = this.props;
		if (_.isEmpty(players_by_id)) {
			return <LoadingSpinner />;
		}

		return (
			<React.Fragment>
				{this.team_player_row}
				{this.team_requests_count < MAX_TRADES  ? (
					<PlayerCellWrapperLast>
						<EmptyInCell is_team />
						<EmptyOutCell is_team />
					</PlayerCellWrapperLast>
				) : null}
				{this.team_buttons}
			</React.Fragment>
		);
	}

	get team_player_row() {
		const { team: { new_player_id, old_player_id } } = this.props;
		const zipped = _.zip(new_player_id, old_player_id);

		return zipped.map(this.getTeamPlayerCells);
	}

	getTeamPlayerCells(ids, index) {
		const {
			players_by_id,
			removeInPlayer,
			removeOutPlayer
		} = this.props;
		const new_player = players_by_id[ids[0]],
			old_player = players_by_id[ids[1]];
		return (
			<PlayerCellWrapper key={index}>
				{ids[0] ? (
					<TradeInCell player={new_player} removePlayer={removeInPlayer} />
				) : (
					<EmptyInCell is_team />
				)}
				{ids[1] ? (
					<TradeOutCell player={old_player} removePlayer={removeOutPlayer} />
				) : (
					<EmptyOutCell is_team />
				)}
			</PlayerCellWrapper>
		);
	}

	get team_buttons() {
		const { team: { new_player_id, old_player_id }, cancelRequest } = this.props;
		const new_players_size = _.size(new_player_id);
		const old_players_size = _.size(old_player_id);
		const is_request_enabled = new_players_size && old_players_size;
		return (
			<ButtonsWrapper>
				<ButtonSecondary onClick={cancelRequest}>
					CANCEL REQUEST
				</ButtonSecondary>
				<ButtonPrimary
					disabled={!is_request_enabled}
					onClick={this.handleTradeConfirmModal}
					className={is_request_enabled ? '' : 'hidden-mobile'}
				>
					MAKE OFFER
				</ButtonPrimary>
			</ButtonsWrapper>
		);
	}
	get trade_confirm_modal() {
		const { team, players_by_id, makeTeamToTeamTrade } = this.props;
		const { new_player_id, old_player_id } = team;
		return (
			<ModalContainer header_text="CONFIRM OFFER" onClick={this.handleTradeConfirmModal}>
				<ModalInnerTitle>
					Please revise and confirm the following offer:
				</ModalInnerTitle>
				<ConfirmModalContent>
					<TradeCells>
						{new_player_id.map(id => (
							<TradeInCell key={id} player={players_by_id[id]} />
						))}
					</TradeCells>
					<BorderedIconStyled background='#fff' className="hidden-mobile" >
						<Trade size="2" />
					</BorderedIconStyled>
					<TradeCells>
						{old_player_id.map(id => (
							<TradeOutCell key={id} player={players_by_id[id]} />
						))}
					</TradeCells>
				</ConfirmModalContent>
				<ButtonsWrapper>
					<ButtonSecondary onClick={this.handleTradeConfirmModal}>
						CANCEL
					</ButtonSecondary>
					<ButtonPrimary
						onClick={makeTeamToTeamTrade}
					>
						CONFIRM OFFER
					</ButtonPrimary>
				</ButtonsWrapper>

			</ModalContainer>
		);
	}

	get isRequestDisabled() {
		const {
			fa: { new_player_id, old_player_id },
			user_team
		} = this.props;
		const {
			is_fa_pending
		} = this.state;
		const { players_margin } = user_team;
		const is_under_margin = players_margin < 0 && new_player_id !== 0;
		const is_request_disabled = [new_player_id, old_player_id].includes(0) && !is_under_margin;
		return is_request_disabled || is_fa_pending;
	}

	get fa_confirm_modal() {
		const {
			players_by_id,
			fa: { new_player_id, old_player_id },
		} = this.props;
		if (_.isEmpty(players_by_id)) {
			return <LoadingSpinner />;
		}
		return (
			<ModalContainer header_text="CONFIRM REQUEST" onClick={this.handleFAConfirmModal}>
				<ModalInnerTitle>
					Please revise and confirm the following request:
				</ModalInnerTitle>
				<ConfirmModalContent>
					<TradeCells>
						{new_player_id ? (
							<TradeInCell player={players_by_id[new_player_id]} />
						) : (
							<EmptyInCell is_team={false} />
						)}
					</TradeCells>
					<BorderedIconStyled background='#fff' className="hidden-mobile" >
						<FA size="2" />
					</BorderedIconStyled>
					<TradeCells>
						{old_player_id ? (
							<TradeOutCell player={players_by_id[old_player_id]} />
						) : null}
					</TradeCells>
				</ConfirmModalContent>
				<ButtonsWrapper>
					<ButtonSecondary onClick={this.handleFAConfirmModal}>
						CANCEL
					</ButtonSecondary>
					<ButtonPrimary
						disabled={this.isRequestDisabled}
						onClick={this.isRequestDisabled ? null : this.makeFARequest}>

						CONFIRM REQUEST
					</ButtonPrimary>
				</ButtonsWrapper>

			</ModalContainer>
		);
	}

	get error_modal() {
		const { trade_error } = this.props;

		return (
			<ModalContainer header_text="Error" onClick={this.handleErrorModalClose}>
				<ModalInnerTitle>
					{trade_error}
				</ModalInnerTitle>
			</ModalContainer>
		);
	}
	handleTradeConfirmModal() {
		const { show_trade_confirm_modal } = this.state;
		this.setState({
			show_trade_confirm_modal: !show_trade_confirm_modal
		});
	}

	handleFAConfirmModal() {
		const { show_fa_confirm_modal } = this.state;
		this.setState({
			show_fa_confirm_modal: !show_fa_confirm_modal
		});
	}
	handleErrorModalClose() {
		const { clearTradeErrors } = this.props;
		clearTradeErrors();
	}
	makeFARequest() {
		const { postRequestWaiver, league, fa } = this.props;
		const { team_id } = league;
		this.setState({
			is_fa_pending: true
		});
		postRequestWaiver({
			...fa,
			team_id
		});
	}

	//helpers
	get team_requests_count() {
		const { team: { new_player_id, old_player_id } } = this.props;

		return _.max([_.size(new_player_id), _.size(old_player_id)]);
	}

	render() {
		const { type, trade_error } = this.props;
		const { show_trade_confirm_modal, show_fa_confirm_modal } = this.state;
		const title = {
			fa: 'Free Agent Request',
			team: 'Team to Team Trade'
		}[type];

		return (
			<div>
				{trade_error ? this.error_modal : null}
				<PlayersOnTradeTitle title={title} />
				{this.requests}
				{show_trade_confirm_modal && this.trade_confirm_modal}
				{show_fa_confirm_modal && this.fa_confirm_modal}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		players_by_id: selectors.players.getExtendedPlayersById(state),
		waiver_requests: state.teamsDraft.waiver_requests,
		trade_error: state.teamsDraft.error
	};
};
const mapDispatchToProps = {
	postRequestWaiver: actions.teamsDraft.postRequestWaiver,
	postRequestWaiverClear: actions.teamsDraft.postRequestWaiverClear,
	clearTradeErrors: actions.teamsDraft.clearTeamErrors,
};

export const PlayersOnTrade = connect(
	mapStateToProps,
	mapDispatchToProps,
)(PlayersOnTradeComponent);

export default PlayersOnTrade;


// WEBPACK FOOTER //
// ./src/components/Trades/PlayersOnTrade.js